"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "./Button/Button.js";
import { PiArrowCounterClockwise } from "react-icons/pi";
const DEFAULT_WRAPPER_CLASS = "flex justify-center py-4 md:py-6";
const BUTTON_CLASS = "min-h-0! gap-2 px-0! py-0! text-center text-sm leading-[120%] font-normal [--cvr-button-background:var(--color-red-900)]";
export const ShowMoreButton = ({ onClick, className = DEFAULT_WRAPPER_CLASS, }) => {
    return (_jsx("div", { className: className, children: _jsxs(Button, { variant: "tertiary-small", className: BUTTON_CLASS, type: "button", onClick: onClick, children: [_jsx(PiArrowCounterClockwise, { className: "h-4 w-4" }), "Vis flere"] }) }));
};
